import React, { Component } from 'react';

import strings from '../../../assets/localization';
import Modal from '../../UI/Modal/Modal';
import NavbarElement from '../../Navigation/Navbar/NavbarElement/NavbarElement';
import Input from '../../UI/Input/Input';
import Button from '../../UI/Button/Button';
import AlertError from '../../Auth/AlertError/AlertError';
import classes from './ContactUsModal.module.css';
import InputError from '../../UI/InputError/InputError';
import config from '../../../constants/config';
import Spinner from '../../UI/Spinner/Spinner';

class ContactUsModal extends Component {
  constructor(props) {
    super(props);
    this.textEmailInput = React.createRef();
    this.state = {
      value: props.preSelectValue || strings.subject0,
      isEmailEmpty: true,
      isMsgTextEmpty: true,
      email: '',
      msgText: '',
    };
  }

  componentDidMount() {
    if (this.state.email === '') {
      this.textEmailInput.focus();
    }
  }

  render() {
    // console.log('Render Contact Us Modal ', this.state.value);
    return (
      <Modal
        navbarLeftElement={
          <NavbarElement
            imgIcon='/sprites.svg#icon-close-small'
            alt='Close'
            clicked={this.props.goBack}
          />
        }
        navbarCenterElement={strings.ContactUsSupport}
      >
        <div style={{ flex: '2.5', width: '100%' }}>
          <Input
            setRef={(component) => {
              this.textEmailInput = component;
            }}
            type='email'
            inputMode='email'
            autoCapitalize='off'
            autoCorrect='off'
            autoComplete='email'
            value={this.state.email}
            onFocus={this.props.onFocus}
            onChange={this.onEmailChange}
            label={strings.WhatIsYourEmail}
            placeholder={strings.EnterEmailAddress}
            maxLength={128}
          />
          {this.renderEmailError()}
          <label className={classes.Label}>{strings.Subject}</label>
          <select
            className={classes.DropDown}
            value={this.state.value}
            onChange={this.handleChange}
          >
            <option value={strings.subject0}>{strings.subject0}</option>
            <option value={strings.subject1}>{strings.subject1}</option>
            <option value={strings.subject2}>{strings.subject2}</option>
            <option value={strings.subject3}>{strings.subject3}</option>
            <option value={strings.subject4}>{strings.subject4}</option>
            <option value={strings.subject5}>{strings.subject5}</option>
          </select>
          <label className={classes.Label}>{strings.HowCanWeHelpU}</label>
          <textarea
            className={classes.TextArea}
            id='text-area'
            name='textarea'
            onChange={this.onTextChange}
            value={this.state.msgText}
            placeholder={strings.WriteMsg}
            maxLength={2048}
          />
          {this.renderMsgTextError()}
        </div>
        <div className={classes.FooterWrapper}>
          <div className={classes.Footer}>
            <Button
              disabled={!this.validateEmailAndText()}
              clicked={this.sendMsg}
            >
              {strings.SendMsg}
            </Button>
          </div>
          {this.props.showSpinner ? this.renderSpinner() : null}
        </div>
        {this.props.showErrorAlert ? (
          <AlertError
            dismissAlert={this.props.dismissAlert}
            errorMessage={this.props.alertMessage}
          />
        ) : null}
      </Modal>
    );
  }
  onEmailChange = (e) => {
    const {
      target: { value },
    } = e;
    this.setState({ email: value });
    const emailLength = value.length;
    if (emailLength === 6) {
      this.setState({ isEmailEmpty: false });
    }
  };

  onTextChange = (e) => {
    const {
      target: { value },
    } = e;
    this.setState({ msgText: value });
    if (value.length === 1) {
      this.setState({ isMsgTextEmpty: false });
    }
  };

  handleChange = (e) => {
    this.setState({ value: e.target.value });
  };

  renderEmailError = () => {
    const { isEmailEmpty } = this.state;
    return (
      <InputError
        style={{
          display: !isEmailEmpty && !this.validateEmail() ? 'block' : 'none',
        }}
      >
        {strings.PleaseEnterValidEmail}
      </InputError>
    );
  };

  renderMsgTextError = () => {
    const { isMsgTextEmpty } = this.state;
    return (
      <InputError
        style={{
          display: !isMsgTextEmpty && !this.validateText() ? 'block' : 'none',
        }}
      >
        {strings.EnterMsg}
      </InputError>
    );
  };

  validateEmail = () => {
    return config.EMAIL_REGEX.test(this.state.email);
  };

  validateText = () => {
    return !config.TEXTAREA_REGEX.test(this.state.msgText);
  };

  validateEmailAndText = () => {
    return this.validateEmail() && this.validateText();
  };

  // API call
  sendMsg = () => {
    this.props.sendMsg(
      this.state.email,
      this.state.msgText.trim(),
      this.state.value
    );
  };

  renderSpinner = () => {
    return (
      <div className={classes.SpinnerWrapper}>
        <Spinner size='Tiny' />
      </div>
    );
  };
}

export default ContactUsModal;



// WEBPACK FOOTER //
// ./src/components/Modals/ContactUsModal/ContactUsModal.js